enum PeriodicityEnum {
	Day = 'day',
	Week = 'week',
	Month = 'month',
	Year = 'year',
}

export default PeriodicityEnum;
